<div class="w-full block">
  <img src="/assets/images/banner.png" alt="banner" class="w-1/2 mx-auto" />
</div>

<div class="bg-white p-4 border-b border-gray-300 z-50">
  <!-- <h1 class="m-0 text-lg font-bold">Dream Talents' Privacy</h1> -->
</div>

<main class="flex items-start p-5">
  <section class="flex-1 pr-5">
    <h2 class="text-black text-[40px] font-bold mb-4">Dream Talents' Privacy Policy</h2>
    <p class="mb-4 text-lg text-black">
      Your privacy is important to us. This Privacy Policy explains how
      <b>Insurance</b> collects, uses, discloses, and protects your information when you use our application to manage Facebook campaigns, ad sets, and ads.
    </p>

    <!-- SECTION 1 -->
    <h3 id="section1" class="text-black font-bold text-[32px] mb-2">1. Information We Collect</h3>
    <p class="mb-2 text-lg">We collect the following types of information when you use our application:</p>

    <h4 class="font-bold text-lg text-black mb-1">1.1. User-Provided Information</h4>
    <ul class="pl-5 font-normal mb-4">
      <li class="relative pl-5 mb-1 text-lg text-black before:content-[''] before:absolute before:left-0 before:top-1/2 before:-translate-y-1/2 before:w-2 before:h-2 before:bg-[#1EA0FF]">
        Facebook account credentials (via secure API integration).
      </li>
      <li class="relative pl-5 mb-1 text-lg text-black before:content-[''] before:absolute before:left-0 before:top-1/2 before:-translate-y-1/2 before:w-2 before:h-2 before:bg-[#1EA0FF]">
        Campaign, ad set, and ad data, including titles, targeting options, budgets, and performance metrics.
      </li>
      <li class="relative pl-5 mb-1 text-lg text-black before:content-[''] before:absolute before:left-0 before:top-1/2 before:-translate-y-1/2 before:w-2 before:h-2 before:bg-[#1EA0FF]">
        Payment information (if applicable, for premium services).
      </li>
      <li class="relative pl-5 mb-1 text-lg text-black before:content-[''] before:absolute before:left-0 before:top-1/2 before:-translate-y-1/2 before:w-2 before:h-2 before:bg-[#1EA0FF]">
        Contact information, such as your name, email address, and phone number.
      </li>
    </ul>

    <h4 class="font-bold text-lg text-black mb-1">1.2. Automatically Collected Information</h4>
    <ul class="pl-5 mb-4">
      <li class="relative pl-5 mb-1 text-lg text-black before:content-[''] before:absolute before:left-0 before:top-1/2 before:-translate-y-1/2 before:w-2 before:h-2 before:bg-[#1EA0FF]">
        Log data, including IP addresses, browser types, operating systems, and timestamps.
      </li>
      <li class="relative pl-5 mb-1 text-lg text-black before:content-[''] before:absolute before:left-0 before:top-1/2 before:-translate-y-1/2 before:w-2 before:h-2 before:bg-[#1EA0FF]">
        Device information, such as device identifiers, operating system version, and app usage metrics.
      </li>
      <li class="relative pl-5 mb-1 text-lg text-black before:content-[''] before:absolute before:left-0 before:top-1/2 before:-translate-y-1/2 before:w-2 before:h-2 before:bg-[#1EA0FF]">
        Facebook API usage data for monitoring and debugging purposes.
      </li>
    </ul>

    <h4 class="font-bold text-lg text-black mb-1">1.3. Cookies and Tracking Technologies</h4>
    <p class="mb-4 text-lg">
      We use cookies, web beacons, and similar technologies to improve user experience, track usage, and gather analytics.
    </p>

    <!-- SECTION 2 -->
    <h3 id="section2" class="text-black font-bold text-[32px] mb-2">2. How We Use Your Information</h3>
    <ul class="pl-5 mb-4">
      <li class="relative pl-5 mb-1 text-lg text-black before:content-[''] before:absolute before:left-0 before:top-1/2 before:-translate-y-1/2 before:w-2 before:h-2 before:bg-[#1EA0FF]">
        To authenticate your access via Facebook APIs.
      </li>
      <li class="relative pl-5 mb-1 text-lg text-black before:content-[''] before:absolute before:left-0 before:top-1/2 before:-translate-y-1/2 before:w-2 before:h-2 before:bg-[#1EA0FF]">
        To enable you to create, manage, and optimize Facebook campaigns, ad sets, and ads.
      </li>
      <li class="relative pl-5 mb-1 text-lg text-black before:content-[''] before:absolute before:left-0 before:top-1/2 before:-translate-y-1/2 before:w-2 before:h-2 before:bg-[#1EA0FF]">
        To provide analytics, performance reports, and insights for your campaigns.
      </li>
      <li class="relative pl-5 mb-1 text-lg text-black before:content-[''] before:absolute before:left-0 before:top-1/2 before:-translate-y-1/2 before:w-2 before:h-2 before:bg-[#1EA0FF]">
        To communicate with you, including responding to inquiries and sending updates or promotional materials (if opted in).
      </li>
      <li class="relative pl-5 mb-1 text-lg text-black before:content-[''] before:absolute before:left-0 before:top-1/2 before:-translate-y-1/2 before:w-2 before:h-2 before:bg-[#1EA0FF]">
        To monitor, detect, and prevent fraud, security breaches, or misuse of the application.
      </li>
    </ul>

    <!-- SECTION 3 -->
    <h3 id="section3" class="text-black font-bold text-[32px] mb-2">3. How We Share Your Information</h3>
    <p class="mb-4 text-lg">We do not sell your personal information to third parties. However, we may share your information in the following scenarios:</p>

    <h4 class="font-bold text-lg text-black mb-1">3.1. With Facebook</h4>
    <p class="mb-2 text-lg">Your campaign, ad set, and ad data are shared with Facebook’s Marketing API for execution.</p>

    <h4 class="font-bold text-lg text-black mb-1">3.2. Service Providers</h4>
    <p class="mb-2 text-lg">We may share data with trusted third-party service providers that help us operate the application (e.g., cloud storage, analytics providers).</p>

    <h4 class="font-bold text-lg text-black mb-1">3.3. Legal Compliance and Protection</h4>
    <p class="mb-4 text-lg">We may disclose information to comply with legal obligations, enforce our policies, or protect against fraudulent or malicious activities.</p>

    <!-- SECTION 4 -->
    <h3 id="section4" class="text-black font-bold text-[32px] mb-2">4. Data Security</h3>
    <p class="mb-2 text-lg">We implement appropriate technical and organizational measures to protect your information, including:</p>
    <ul class="pl-5 mb-4">
      <li class="relative pl-5 mb-1 text-lg text-black before:content-[''] before:absolute before:left-0 before:top-1/2 before:-translate-y-1/2 before:w-2 before:h-2 before:bg-[#1EA0FF]">
        Encryption of sensitive data, such as tokens and payment information.
      </li>
      <li class="relative pl-5 mb-1 text-lg text-black before:content-[''] before:absolute before:left-0 before:top-1/2 before:-translate-y-1/2 before:w-2 before:h-2 before:bg-[#1EA0FF]">
        Secure access controls to protect against unauthorized access.
      </li>
      <li class="relative pl-5 mb-1 text-lg text-black before:content-[''] before:absolute before:left-0 before:top-1/2 before:-translate-y-1/2 before:w-2 before:h-2 before:bg-[#1EA0FF]">
        Regular audits and updates to security practices.
      </li>
    </ul>
    <p class="mb-4 text-lg">Despite our efforts, no method of transmission or storage is completely secure. Use our services at your own risk.</p>

    <!-- SECTION 5 -->
    <h3 id="section5" class="text-black font-bold text-[32px] mb-2">5. Your Rights</h3>
    <p class="mb-2 text-lg">Depending on your jurisdiction, you may have the following rights regarding your personal information:</p>

    <h4 class="font-bold text-lg text-black mb-1">5.1. Access and Correction</h4>
    <p class="mb-2 text-lg">You can access and update your personal information through your account settings.</p>

    <h4 class="font-bold text-lg text-black mb-1">5.2. Data Deletion</h4>
    <p class="mb-2 text-lg">
      You may request the deletion of your account and associated data by contacting us at 
      <a href="mailto:quoctran160784&#64;gmail.com" class="text-[#1EA0FF] underline">quoctran160784&#64;gmail.com</a>
    </p>

    <h4 class="font-bold text-lg text-black mb-1">5.3. Data Portability</h4>
    <p class="mb-2 text-lg">You can request a copy of your data in a machine-readable format.</p>

    <h4 class="font-bold text-lg text-black mb-1">5.4. Opt-Out</h4>
    <p class="mb-2 text-lg">You may opt out of marketing communications at any time.</p>
    <p class="mb-4 text-lg">
      To exercise these rights, contact us at 
      <a href="mailto:quoctran160784&#64;gmail.com" class="text-[#1EA0FF] underline">quoctran160784&#64;gmail.com</a>
    </p>

    <!-- SECTION 6 -->
    <h3 id="section6" class="text-black font-bold text-[32px] mb-2">6. Data Retention</h3>
    <p class="mb-4 text-lg">We retain your data only for as long as necessary to fulfill the purposes outlined in this policy, comply with legal obligations, or resolve disputes.</p>

    <!-- SECTION 7 -->
    <h3 id="section7" class="text-black font-bold text-[32px] mb-2">7. Third-Party Links</h3>
    <p class="mb-4 text-lg">Our application may include links to third-party websites or services. We are not responsible for the privacy practices of these third parties. Please review their privacy policies.</p>

    <!-- SECTION 8 -->
    <h3 id="section8" class="text-black font-bold text-[32px] mb-2">8. International Data Transfers</h3>
    <p class="mb-4 text-lg">If you are accessing our application from outside Vietnam, your data may be transferred to and processed in Vietnam, where data protection laws may differ from your jurisdiction.</p>

    <!-- SECTION 9 -->
    <h3 id="section9" class="text-black font-bold text-[32px] mb-2">9. Changes to This Privacy Policy</h3>
    <p class="mb-4 text-lg">We reserve the right to update this Privacy Policy at any time. We will notify you of significant changes via in-app notifications or email.</p>

    <!-- SECTION 10 -->
    <h3 id="section10" class="text-black font-bold text-[32px] mb-2">10. Contact Us</h3>
    <p class="mb-2 text-lg">If you have any questions or concerns about this Privacy Policy, please contact us at:</p>
    <p class="mb-1 text-lg"><strong>Email: </strong> 
      <a href="mailto:quoctran160784&#64;gmail.com" class="text-[#1EA0FF] underline">quoctran160784&#64;gmail.com</a>
    </p>
    <p class="mb-1 text-lg"><strong>Phone: </strong> (+84)974.320.426</p>
    <p class="mb-4 text-lg"><strong>Address: </strong> 1424 N Brown Rd #450, Lawrenceville, Georgia United States</p>
  </section>

  <!-- TOC -->
	<nav class="sticky top-5 max-h-[80vh] overflow-y-auto p-4 bg-[#f8f9fa] border-l-2 border-gray-300 min-w-[250px]">
		<h2 class="text-black text-[32px] pb-4">Table of contents</h2>
		<ul class="list-none text-lg flex flex-col gap-2">
			<li *ngFor="let item of tocItems">
				<a (click)="scrollTo(item.id)" 
					class="no-underline text-black cursor-pointer hover:underline">
					{{ item.title }}
				</a>
			</li>
		</ul>
	</nav>
</main>
